<template>
  <div style="position:relative">
    <validation-provider v-slot="{errors}"
                         ref="innerRef"
                         :vid="$attrs.vid"
                         :name="$attrs.vname"
                         :mode="mode"
                         :rules="rules"
                         :bails="bails"
                         style="position: relative">

      <v-text-field v-model="innerValue"
                    :error-messages="resolveErrorMessagesHidden(errors)"
                    :error="errors.length > 0"
                    :id="$attrs.vid"
                    :autocomplete="autocomplete"
                    v-bind="$attrs"
                    v-on="$listeners"
                    :dont-fill-mask-blanks="true"
                    :validate-on-blur="true">
                    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
                    </v-text-field>

      <!-- <input type="text"
             :error="errors.length > 0"
             v-model="innerValue"
             :style="errors.length > 0?'background-color: blue;padding:10px':''"
             v-on="$listeners">
      <span v-if="errors.length > 0">{{resolveErrorMessagesHidden(errors)}}</span> -->

    </validation-provider>

  </div>
</template>
<script>
import BaseInputValidate from './BaseInputValidate'
export default {
  name: 'b-text-field',

  extends: BaseInputValidate,

  props: {
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  methods: {}
}
</script>
